import { render, staticRenderFns } from "./Independence.vue?vue&type=template&id=2b3b1bdd&scoped=true"
import script from "./Independence.vue?vue&type=script&lang=js"
export * from "./Independence.vue?vue&type=script&lang=js"
import style0 from "./Independence.vue?vue&type=style&index=0&id=2b3b1bdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b1bdd",
  null
  
)

export default component.exports